import { IPartyData } from "ui-toolkit/orders/interfaces/IParty";

export interface ISignerResponse {
  id: string;
  personId?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  person?: IPartyData;
  signatory?: { id: string };
}

export const getSignerDisplayNames = ({ firstName, lastName, middleName }: ISignerResponse) => {
  const firstNames = middleName ? `${firstName} ${middleName}` : firstName;
  return `${firstNames} ${lastName}`;
};
